export interface SummaryFormValues {
  [FIELDS.OFFER_TERMS_AGREEMENT]: boolean;
  [FIELDS.REFUSE_NEWSLETTER]: boolean;
  [FIELDS.IBAN_CODE]: string;
}

export enum FIELDS {
  TITLE = 'title',
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  CITY = 'city',
  POSTAL_CODE = 'postalCode',
  COUNTRY_CODE = 'countryCode',
  ADDRESS = 'address',
  ADDRESS_COMPLEMENT = 'additionalAddress',
  MOBILE_PHONE_NUMBER = 'mobilePhoneNumber',
  EMAIL = 'email',
  IBAN_CODE = 'ibanCode',
  REFUSE_NEWSLETTER = 'refuseNewsletter',
  OFFER_TERMS_AGREEMENT = 'offerTermsAgreement'
}

export enum ACTION_TYPES {
  SET_OFFER = '@OneShop/SUMMARY_SET_OFFER',
  INVALID_OFFER = '@OneShop/SUMMARY_INVALID_OFFER',
  FLUSH = '@OneShop/SUMMARY_FLUSH',
  PENDING = '@OneShop/SUMMARY_PENDING',
  SUBMIT_PENDING = '@OneShop/SUMMARY_SUBMIT_PENDING',
  SUBMIT_SUCCESS = '@OneShop/SUMMARY_SUBMIT_OFFER_SUCCESS',
  SUBMIT_ERROR = '@OneShop/SUMMARY_SUBMIT_OFFER_ERROR'
}

export const INITIAL_DEFAULT_VALUES: SummaryFormValues = {
  [FIELDS.OFFER_TERMS_AGREEMENT]: false,
  [FIELDS.IBAN_CODE]: '',
  [FIELDS.REFUSE_NEWSLETTER]: false
};
